<eif-custom-toaster></eif-custom-toaster>

<div class="app">
	<nav
		class="app-nav"
		[ngClass]="{ collapsed: isCollapsed }">
		<div class="app-nav-main">
			<div class="app-nav-logo">
				<a [routerLink]="['/private/home']">
					<img
						class="logo-large"
						src="assets/images/logo-flexcash-app.svg" />
					<img
						class="logo-small"
						src="assets/images/logo_small.png" />
				</a>
			</div>

			<div class="app-nav-groups">
				@for (group of navigationMenuItems | keyvalue: noSort; track group.key) {
					@if (group.value.condition !== false) {
						<div class="app-nav-group">
							@if (group.value.title) {
								<div class="app-nav-group-title is-label">
									<div
										class="title-first-letter"
										[eifTooltip]="isCollapsed ? group.value.title : null">
										{{ group.value.title.charAt(0) }}
									</div>
									<div class="title-remaining">{{ group.value.title.substring(1) }}</div>
								</div>
							}
							@for (item of group.value.items; track $index) {
								@if (item.condition !== false) {
									<button
										[eifTooltip]="isCollapsed ? item.text : null"
										class="nav-button"
										[class.selected]="isMenuSelected(item.path)"
										(click)="item.action($event)"
										type="button">
										<span class="button-icon">
											@if (item.icon) {
												<i [class]="item.icon"> </i>
											}
										</span>
										@if (item.text) {
											<span class="button-text truncate">
												{{ item.text }}
											</span>
										}
									</button>
								}
							}
						</div>
					}
				}
			</div>
		</div>

		<div class="app-nav-footer">
			<div #verticalActions>
				<div class="app-nav-footer-actions vertical">
					<ng-container *ngTemplateOutlet="footerActions"></ng-container>
				</div>
			</div>
			<div class="app-nav-footer-actions-wrapper">
				<eif-custom-button
					[variant]="['icon', 'text']"
					[color]="'neutral'"
					[preIcon]="getToggleIconHTML()"
					[tooltip]="getToggleTooltip()"
					[size]="'large'"
					(action)="toggleNavbar()">
				</eif-custom-button>
				<div #horizontalActions>
					<div class="app-nav-footer-actions horizontal">
						<ng-container *ngTemplateOutlet="footerActions"></ng-container>
					</div>
				</div>
			</div>
		</div>

		<ng-template #footerActions>
			@if (canSeeAdminPanel) {
				<eif-custom-button
					[color]="'neutral'"
					[variant]="['icon', 'text']"
					[preIcon]="'fa-solid fa-gear'"
					[tooltip]="'menu.adminPanel'"
					[size]="'large'"
					(action)="openAdminPage()">
				</eif-custom-button>
			}
			<eif-custom-button
				[variant]="['icon', 'text']"
				[preIcon]="'fa-solid fa-question-circle'"
				[tooltip]="'menu.helpCenter'"
				[size]="'large'"
				(action)="goToHelpCenter()">
			</eif-custom-button>
			<eif-custom-menu
				[color]="'neutral'"
				[variant]="['icon', 'text']"
				[preIcon]="'fa-solid fa-user-circle'"
				[tooltip]="'menu.userProfile'"
				[menuItems]="userMenuItems"
				[size]="'large'"
				[context]="'user-menu'">
			</eif-custom-menu>
		</ng-template>
	</nav>
	<!-- Debug: isCollapsed = {{ isCollapsed }} -->

	<!-- Mobile Navigation Overlay -->
	@if (isMobile) {
		<div
			class="mobile-nav-overlay"
			[class.open]="isMobileMenuOpen || isUserMenuOpen"
			(click)="closeMobileMenu(); closeUserMenu()"></div>
	}

	<!-- Mobile Navigation Drawer (Main Menu) -->
	@if (isMobile) {
		<nav
			class="mobile-nav mobile-nav-left"
			[class.open]="isMobileMenuOpen">
			<div class="mobile-nav-header">
				<div class="mobile-nav-logo">
					<a [routerLink]="['/private/home']">
						<img
							class="logo-large"
							src="assets/images/logo-flexcash-app.svg" />
					</a>
				</div>
				<eif-custom-button
					[variant]="['icon', 'text']"
					[color]="'neutral'"
					[preIcon]="'fa-light fa-times'"
					(action)="closeMobileMenu()">
				</eif-custom-button>
			</div>
			<div class="mobile-nav-main">
				<div class="mobile-nav-groups">
					@for (group of navigationMenuItems | keyvalue: noSort; track group.key) {
						@if (group.value.condition !== false) {
							<div class="mobile-nav-group">
								@if (group.value.title) {
									<div class="mobile-nav-group-title">
										{{ group.value.title }}
									</div>
								}
								@for (item of group.value.items; track $index) {
									@if (item.condition !== false) {
										<button
											class="nav-button"
											[class.selected]="isMenuSelected(item.path)"
											(click)="item.action()"
											type="button">
											<div class="button-icon">
												@if (item.icon) {
													<i [class]="item.icon"> </i>
												}
											</div>
											@if (item.text) {
												<span class="button-text truncate">
													{{ item.text }}
												</span>
											}
										</button>
									}
								}
							</div>
						}
					}
				</div>
			</div>
		</nav>
	}

	<!-- Mobile User Menu Drawer (Right Side) -->
	@if (isMobile) {
		<nav
			class="mobile-nav mobile-nav-right mobile-user-menu"
			[class.open]="isUserMenuOpen">
			<div class="mobile-nav-header">
				<eif-user-name-label
					[userName]="loggedUser?.Name"
					[userEmail]="loggedUser?.Email">
				</eif-user-name-label>
				<eif-custom-button
					[variant]="['icon', 'text']"
					[color]="'neutral'"
					[preIcon]="'fa-light fa-times'"
					(action)="closeUserMenu()">
				</eif-custom-button>
			</div>
			<div class="mobile-nav-main">
				<div class="mobile-nav-groups">
					<div class="mobile-nav-group">
						<!-- User Menu Items -->
						@for (menuItem of userMenuItems; track $index; let i = $index) {
							@if (i > 1 && menuItem.text) {
								<!-- Show button for items with or without children -->
								@if (menuItem.condition !== false && (!menuItem.children || menuItem.children.length === 0 || menuItem.action)) {
									<eif-custom-button
										[text]="menuItem.text"
										[preIcon]="menuItem.icon"
										[color]="'neutral'"
										[variant]="'text'"
										[align]="'start'"
										[borderRadius]="false"
										[fullWidth]="true"
										(action)="handleUserMenuAction(menuItem.action)">
									</eif-custom-button>
								}
								<!-- Show button for items with children but no action (like Change Profile) -->
								@if (menuItem.condition !== false && menuItem.children && menuItem.children.length > 0 && !menuItem.action) {
									<eif-custom-button
										[text]="menuItem.text"
										[preIcon]="menuItem.icon"
										[color]="'neutral'"
										[variant]="'text'"
										[align]="'start'"
										[borderRadius]="false"
										[fullWidth]="true"
										[disabled]="true">
									</eif-custom-button>
								}
								<!-- Submenu items (for profile switching) -->
								@if (menuItem.children && menuItem.children.length > 0 && menuItem.condition !== false) {
									<div class="mobile-user-submenu">
										@for (child of menuItem.children; track $index) {
											<eif-custom-button
												[text]="child.text"
												[postIcon]="child.selected ? 'fa-light fa-check' : undefined"
												[color]="'neutral'"
												[variant]="'text'"
												[align]="'start'"
												[borderRadius]="false"
												[fullWidth]="true"
												[class]="child.selected ? 'selected' : ''"
												(action)="handleUserMenuAction(child.action)">
											</eif-custom-button>
										}
									</div>
								}
							}
						}
					</div>
				</div>
			</div>
		</nav>
	}

	<div class="app-content">
		<header class="app-header">
			<div class="app-header-left">
				@if (isMobile) {
					<eif-custom-button
						[variant]="['icon', 'text']"
						[color]="'neutral'"
						[preIcon]="'fa-light fa-bars'"
						[tooltip]="'menu.toggleExpand'"
						(action)="toggleMobileMenu()">
					</eif-custom-button>
				}
				<div class="app-header-user">
					<div>{{ 'home.welcome.user' | translate }} {{ loggedUser?.Name }}</div>
					<div class="is-bold">({{ logUsrAssociatedRle }})</div>
				</div>
			</div>
			@if (isMobile) {
				<div class="app-header-right mobile-header-actions">
					@if (canSeeAdminPanel) {
						<eif-custom-button
							[color]="'neutral'"
							[variant]="['icon', 'text']"
							[preIcon]="'fa-solid fa-gear'"
							[tooltip]="'menu.adminPanel'"
							[size]="'large'"
							(action)="openAdminPage()">
						</eif-custom-button>
					}
					<eif-custom-button
						[variant]="['icon', 'text']"
						[preIcon]="'fa-solid fa-question-circle'"
						[tooltip]="'menu.helpCenter'"
						[size]="'large'"
						(action)="goToHelpCenter()">
					</eif-custom-button>
					<eif-custom-menu
						[color]="'neutral'"
						[variant]="['icon', 'text']"
						[preIcon]="'fa-solid fa-user-circle'"
						[tooltip]="'menu.userProfile'"
						[menuItems]="userMenuItems"
						[size]="'large'"
						[context]="'user-menu'">
					</eif-custom-menu>
				</div>
			}
		</header>
		<main class="app-body"><router-outlet></router-outlet></main>
		<footer class="app-footer">&copy; {{ getCurrentYear() }} Sovos Compliance, LLC.</footer>
	</div>
</div>
